/**
 * Created by robert.lavoie on 6/18/17.
 */

import { Component, OnInit, Inject, PLATFORM_ID, HostBinding } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

// Components
import { JobDetailComponent } from '../job-detail/job-detail.component';

// Models
import { Site } from 'careerpages-base/models';
import { JobQueryParams } from '../../models';

// Services
import { ReportingService, SiteService } from '../../services';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

// Global state variable
import { lastSearchState } from '../../models/job-query-params';


/**
 *
 * @class
 * CustomerSiteComponent
 *
 * @description
 * This component shows the customer site
 *
 */
@Component({
  templateUrl: './customer-site.component.html',
  selector: 'customer-site',
})
export class CustomerSiteComponent implements OnInit {

  public site: Site;
  @HostBinding('class') themeFontClass = '';

  // State for header button
  private showBackButton: boolean;
  private backButtonParams: JobQueryParams;

  constructor(
    private siteService: SiteService,
    private reportingService: ReportingService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {

    this.site = this.siteService.getSite();

    if (isPlatformBrowser(this.platformId)) {

      // Dynamically load the customers font
      // tslint:disable-next-line:variable-name
      const WebFont = require('webfontloader');
      WebFont.load({
        classes: false,
        google: {
          families: [`${this.site['theme']['font']}:300,400,700`]
        }
      });

      // Slugify the site theme font name and add it as a class to the body
      this.themeFontClass = this.site['theme']['font'].toLowerCase()
          .replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
          .replace(/[\s_-]+/g, '-') // swap any length of whitespace, underscore, hyphen characters with a single -
          .replace(/^-+|-+$/g, '');

    }

    // Back Button logic
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Show the back button if we are on the job details page
        if (this.route.firstChild && this.route.firstChild.component == JobDetailComponent) {
          // Remove undefined object params, one liner
          lastSearchState.params = JSON.parse(JSON.stringify(lastSearchState.params));
          this.showBackButton = true;
          this.backButtonParams = lastSearchState.params;
        } else {
          this.showBackButton = false;
          this.backButtonParams = {};
        }
      }
    });

  }

  // Pass the click event from the children components to the reporting service
  handleClick(event) {
    this.reportingService.trackCustomEvent(event);
  }

  /**
   * Redirects back to search results
   */
  backButton() {
    this.router.navigate([''], { queryParams: this.backButtonParams, fragment: 'job-results' });
  }

  /**
   * Handles redirecting to the homepage if necessary and scrolling to the job search
   */
  searchJobs() {
    // Return if we are not a browser
    if (!isPlatformBrowser(this.platformId)) return;

    // If we are not on the homepage, use existing back button logic
    if (this.showBackButton) {
      this.backButton();
    } else {

      // Otherwise, scroll down to the search results
      const searchResults = document.getElementById('job-results');
      if (searchResults && searchResults.scrollIntoView) {
        searchResults.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

}
